import { useFeatureFlagEnabled } from '@posthog/react';
export const EXPORT_ENABLE_LAYER_PICKER_V2 = 'export-enable-layer-picker-v2';

export const useExportEnableLayerPickerV2 = () => {
  return useFeatureFlagEnabled(EXPORT_ENABLE_LAYER_PICKER_V2) === true;
};
